import EventEmitter from "./EventEmitter"

export default class Cursor extends EventEmitter
{
    constructor(_options)
    {
        super()

        this.sizes = _options.sizes
        this.ui = _options.ui

        this.x = 0
        this.y = 0
        this.drag = false
        this._dragFlag = false
        this.setCursorHandlers()
    }

    setCursorHandlers()
    {
        document.addEventListener('pointerdown', (e) =>
        {
            this.drag = false
            this._dragFlag = true
            this.x =  (e.clientX / this.sizes.width) * 2 - 1
            this.y = -(e.clientY / this.sizes.height) * 2 + 1
        })
        document.addEventListener('pointermove', (e) =>
        {
            if(this._dragFlag)
            {
                this.drag = true
            }
            this.x =  (e.clientX / this.sizes.width) * 2 - 1
            this.y = -(e.clientY / this.sizes.height) * 2 + 1

        })
        document.addEventListener('pointerup', (e) =>
        {
            if(this.drag)
            {
                this.trigger('pointerup')
            }
            else
            {
                e.target.parentNode.id === 'webgl' ? this.trigger('3dclick') : this.trigger('click')
            }

            this.drag = false
            this._dragFlag = false
        })
        document.querySelector('#webgl').addEventListener('pointerup', (e) =>
        {
            // this.ui.closeSlideMenu()
        })
    }

    forceUpdate()
    {
        document.dispatchEvent(new Event('pointermove'))
    }
}
